module.exports = __webpack_public_path__ + "img/skilled_helper.61f4bd5e.jpg";